<template>
  <div>
    <h4 class="mb-4">
      {{ $t("account.set_phone_login_title", "Login by Phone") }}
    </h4>

    <accountSetPhoneLogin :defaultCountry="defaultCountry" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { mapState } from "vuex";

import accountSetPhoneLogin from "@/components/accountSetPhoneLogin.vue";

export default defineComponent({
  name: "SetPhoneLogin",
  components: {
    accountSetPhoneLogin,
  },
  computed: {
    ...mapState({
      defaultCountry: (s) => s.account.userCountry,
    }),
  },
});
</script>

<style lang="scss" scoped></style>
